<template>
  <section>
    <report-filter-bar
      v-model="filter"
      :preset="preset"
      :busy="isAnyLoading"
      :compare-label="compareLabel"
      :show-paid-only="false"
      @preset="applyPreset"
      @change="refresh"
      @refresh="refresh"
    />

    <b-row>
      <b-col cols="12">
        <b-alert
          variant="info"
          show
          class="mb-1"
        >
          <b-card-body class="py-75 px-1">
            <feather-icon
              icon="InfoIcon"
              size="15"
            />
            <span class="ml-50 small">
              جدول خطاها ستون سایت ندارد، پس «خطای ثبت‌شده» مربوط به کل نصب است
              نه فقط این سایت. آمار پاسخ‌های ۴۰۴ و ۵xx و درخواست‌های کند مخصوص همین سایت است.
            </span>
          </b-card-body>
        </b-alert>
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        cols="12"
        class="mb-1"
      >
        <report-chart
          :series="health"
          title="سلامت فنی"
          :subtitle="rangeLabel"
          :metrics="['errors', 'serverErrors', 'notFound', 'slow']"
          type="line"
          :height="320"
          :loading="loading('health')"
          :skin="skin"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col
        cols="12"
        class="mb-1"
      >
        <report-table
          :breakdown="errors"
          title="پرتکرارترین خطاها"
          subtitle="مرتب بر اساس تعداد تکرار در بازه"
          label-title="پیام خطا"
          :show-share="false"
          :loading="loading('errors')"
          empty-text="در این بازه خطایی ثبت نشده است"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-card no-body>
          <b-card-body class="d-flex align-items-center justify-content-between flex-wrap">
            <div>
              <h5 class="mb-25">
                جزئیات خطاها
              </h5>
              <span class="text-muted small">برای دیدن stack trace و علامت‌زدن به‌عنوان حل‌شده</span>
            </div>
            <b-button
              variant="outline-primary"
              size="sm"
              @click="$router.push({ name: 'listErrors' })"
            >
              <feather-icon
                icon="ExternalLinkIcon"
                size="14"
              />
              <span class="ml-25">صفحه‌ی خطاها</span>
            </b-button>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BAlert, BCardBody } from 'bootstrap-vue'
import reportMixin from '@core/mixins/report'

export default {
  name: 'ReportOperations',
  components: { BAlert, BCardBody },
  mixins: [reportMixin],
  data() {
    return {
      health: null,
      errors: null,
    }
  },
  computed: {
    compareLabel() {
      return this.health && this.health.CompareRange ? this.health.CompareRange.Label : null
    },
  },
  created() {
    this.filter.PaidOnly = false
    this.refresh()
  },
  methods: {
    refresh() {
      this.fetchReport('health', this.$api.report.operationHealth)
      this.fetchReport('errors', this.$api.report.operationErrors)
    },
  },
}
</script>
